import Vue from 'vue'
import datePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import jQuery from 'jquery'

Vue.use(datePicker)

jQuery.extend(true, jQuery.fn.datetimepicker.defaults, {
    icons: {
        time: 'fa fa-clock',
        date: 'fa fa-calendar',
        up: 'fa fa-arrow-up',
        down: 'fa fa-arrow-down',
        previous: 'fa fa-chevron-left',
        next: 'fa fa-chevron-right',
        today: 'fa fa-calendar-check',
        clear: 'fa fa-trash-alt',
        close: 'fa fa-times-circle'
    }
})

Vue.prototype.$datePickerOptions = {
    format: 'DD/MM/YYYY',
    useCurrent: true,
    locale: 'pt-BR'
}

Vue.prototype.$datePickerOptions2 = {
    format: 'DD/MM/YYYY',
    useCurrent: false,
    locale: 'pt-BR'
}

Vue.prototype.$monthPickerOptions = {
    format: 'MM/YYYY',
    useCurrent: true,
    locale: 'pt-BR',
    viewMode: 'months'
}
